export enum MegaMenuItemTypes {
  service,
  category
}
